//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'underscore'
// import DIC from '@/index/dictonary'

export default {
  props: {

  },
  data: function () {
    let tab = this.$route.query.tab || 'allocate'
    return {
      currentTab: tab
      // currentTab: 'pick'
    }
  },
  watch: {
    '$route.query.tab': {
      handler (val) {
        if (val) {
          // console.log('val', val)
          this.currentTab = val
        }
      },
      deep:true
    },
  },
  components: {
    PageAllocate: () => import('./components/PageAllocate/index.vue'),
    PageDealer: () => import('@/index/pages/operate/goods/goodsTabs/components/PageDealer/index.vue'),
    PagePick: () => import('./components/PagePick/index.vue'),
    PagePickLocation: () => import('./components/PagePickLocation/index.vue'),
    PagePickPoint: () => import('./components/PagePickPoint/index.vue'),
    PageCourier: () => import('./components/PageCourier/index.vue')
  },
  mounted () {

  },
  methods: {

  }
}
